import React, { useState } from 'react';
import { Container, Typography, Box, Grid, Paper, useTheme } from '@mui/material';
import CustomDatePicker from '../components/Common/CustomDatePicker';

/**
 * 日期选择器演示页面，用于展示和测试自定义日期选择器组件
 */
const DatePickerDemo = () => {
  const theme = useTheme();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [singleDate, setSingleDate] = useState(new Date());

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }} align="center">
        日期选择器样式演示
      </Typography>
      
      <Box sx={{ mb: 5 }}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          组件介绍
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
          此页面展示了自定义的日期选择器组件，风格与网站整体设计保持一致。
          日期选择器组件基于react-calendar库开发，支持自定义格式、样式，并提供了友好的用户交互体验。
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {/* 标准使用案例 */}
        <Grid item xs={12} md={6}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 3, 
              borderRadius: '16px',
              border: `1px solid ${theme.palette.divider}`,
              height: '100%'
            }}
          >
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
              基本用法
            </Typography>
            
            <Box sx={{ mb: 4 }}>
              <CustomDatePicker 
                label="请选择日期"
                value={singleDate}
                onChange={setSingleDate}
                fullWidth
              />
            </Box>
            
            <Box>
              <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                选择结果: {singleDate ? singleDate.toLocaleDateString('zh-CN') : '未选择'}
              </Typography>
            </Box>
          </Paper>
        </Grid>
        
        {/* 日期范围案例 */}
        <Grid item xs={12} md={6}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 3, 
              borderRadius: '16px',
              border: `1px solid ${theme.palette.divider}`,
              height: '100%'
            }}
          >
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
              日期范围选择
            </Typography>
            
            <Box sx={{ mb: 3 }}>
              <CustomDatePicker 
                label="开始日期"
                value={startDate}
                onChange={setStartDate}
                fullWidth
              />
            </Box>
            
            <Box sx={{ mb: 4 }}>
              <CustomDatePicker 
                label="结束日期"
                value={endDate}
                onChange={setEndDate}
                fullWidth
              />
            </Box>
            
            <Box>
              <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                开始日期: {startDate ? startDate.toLocaleDateString('zh-CN') : '未选择'}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                结束日期: {endDate ? endDate.toLocaleDateString('zh-CN') : '未选择'}
              </Typography>
            </Box>
          </Paper>
        </Grid>
        
        {/* 自定义格式案例 */}
        <Grid item xs={12}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 3, 
              borderRadius: '16px',
              border: `1px solid ${theme.palette.divider}`
            }}
          >
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 600 }}>
              其他自定义选项
            </Typography>
            
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <CustomDatePicker 
                  label="自定义格式 (yyyy/MM/dd)"
                  value={new Date()}
                  dateFormat="yyyy/MM/dd"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomDatePicker 
                  label="MM-dd-yyyy 格式"
                  value={new Date()}
                  dateFormat="MM-dd-yyyy"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <CustomDatePicker 
                  label="带时间的格式"
                  value={new Date()}
                  dateFormat="yyyy-MM-dd HH:mm"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DatePickerDemo; 